export function getBackendErrorCode<T>(err: any): T {
  return (
    err.graphQLErrors?.[0]?.extensions?.code ||
    err.networkError?.error?.errors?.[0]?.extensions.code ||
    err[0]?.extensions?.code ||
    'UNKNOWN_ERROR'
  )
}
